import { render } from "./DiscountForm.vue?vue&type=template&id=331ddab6&scoped=true"
import script from "./DiscountForm.vue?vue&type=script&lang=js"
export * from "./DiscountForm.vue?vue&type=script&lang=js"

import "./DiscountForm.vue?vue&type=style&index=0&id=331ddab6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331ddab6"]])

export default __exports__